var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1199_4303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8739 11.9687C22.8739 5.94589 17.9914 1.06348 11.9687 1.06348C5.94589 1.06348 1.06348 5.94589 1.06348 11.9687C1.06348 17.4118 5.05134 21.9233 10.2647 22.7414V15.1209H7.49584V11.9687H10.2647V9.56612C10.2647 6.833 11.8928 5.32332 14.3838 5.32332C15.5769 5.32332 16.8249 5.53631 16.8249 5.53631V8.22001H15.4498C14.0951 8.22001 13.6726 9.06063 13.6726 9.92304V11.9687H16.6971L16.2136 15.1209H13.6726V22.7414C18.886 21.9233 22.8739 17.4118 22.8739 11.9687Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2139 15.1209L16.6973 11.9686H13.6729V9.92294C13.6729 9.06055 14.0953 8.21993 15.45 8.21993H16.8251V5.53623C16.8251 5.53623 15.5772 5.32324 14.384 5.32324C11.893 5.32324 10.265 6.83292 10.265 9.56604V11.9686H7.49609V15.1209H10.265V22.7413C10.8287 22.8296 11.3984 22.8739 11.9689 22.8738C12.5486 22.8738 13.1176 22.8284 13.6729 22.7413V15.1209H16.2139Z",
    fill: "#F1F5F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1199_4303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.df815e58f046c2994c9ec8ddcf63c5ac.svg";
export { ForwardRef as ReactComponent };